import { AuthoritiesType } from '@/types/Authority';
import { Button, Result } from 'antd';
import { useHistory } from 'react-router-dom';
import './styles.less';

interface AccessDeniedProps {
  permission?: AuthoritiesType[];
  isHome?: boolean;
}

export default function AccessDenied({ isHome }: AccessDeniedProps) {
  const history = useHistory();
  return (
    <Result
      status="403"
      title={<strong>Acesso Negado!</strong>}
      subTitle="Você não tem permissão para acessar esta página."
      extra={
        !isHome && (
          <Button onClick={() => history.push('/app/dashboard')} type="primary">
            Ir para o ínicio
          </Button>
        )
      }
    />
  );
}
